module.exports = __webpack_public_path__ + "img/amx-14.af18dedc.jpg";